import table from "../data/tables/vfx/presets.json";
import type { VfxPresetTable } from "./types";

const data = table as unknown as VfxPresetTable;

/** Preset id list — no Phaser (safe for Node Vitest). */
export function listVfxPresetIds(): string[] {
  return Object.keys(data.presets);
}

export function hasVfxPreset(id: string): boolean {
  return Boolean(data.presets[id]);
}
